export default __webpack_public_path__ + "static/media/card-p-holder.2a7017ed.svg";